/* Unconform PDP — buy box, sticky bar, FAQ, gallery. Dependency-free.
   Reads config from data- attributes on [data-uc-pdp]. Subscribe options
   only appear when the product has selling plans (data-has-sub="true"). */
(function () {
  function money(cents) { return '£' + (Math.round(cents) / 100).toFixed(2); }

  function initPDP(root) {
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var price = parseInt(root.dataset.price || '0', 10);          // pence, one-time per pack
    var servings = parseInt(root.dataset.servings || '1', 10);
    var unit = root.dataset.unit || 'serving';
    var subDisc = parseFloat(root.dataset.subDiscount || '0');     // 0–1
    var hasSub = root.dataset.hasSub === 'true';
    var variantId = root.dataset.variant;
    var addUrl = root.dataset.cartAdd || '/cart/add.js';
    var cartUrl = root.dataset.cartUrl || '/cart';
    var toCheckout = root.dataset.ucCheckout === 'true';   // opt-in: skip the drawer, go straight to checkout
    var checkoutUrl = root.dataset.checkoutUrl || '/checkout';

    var state = { plan: hasSub ? 'sub' : 'one', stack: 1, qty: 1, planId: root.dataset.defaultPlan || '' };
    function subUnit() { return price * (1 - subDisc); }

    function render() {
      var sub = state.plan === 'sub';
      var subOpts = q('[data-sub-opts]'); if (subOpts) subOpts.style.display = sub ? 'block' : 'none';
      var stepper = q('[data-stepper]'); if (stepper) stepper.style.display = sub ? 'none' : 'flex';
      var u = sub ? subUnit() : price;
      var count = sub ? state.stack : state.qty;
      var total = u * count;
      var per = u / servings;
      var pm = q('[data-price-main]');
      if (pm) pm.innerHTML = money(total) + ' <span class="per">· ' + money(per) + ' / ' + unit + '</span>';
      qa('[data-atc-price]').forEach(function (e) { e.textContent = money(total); });
      var ps = q('[data-plan-toggle="sub"]'), po = q('[data-plan-toggle="one"]');
      if (ps) ps.setAttribute('aria-pressed', String(sub));
      if (po) po.setAttribute('aria-pressed', String(!sub));
      var sp = q('[data-sticky-price]');
      if (sp) sp.textContent = money(total) + (sub ? ' · Subscribe' : ' · One-time');
    }

    qa('[data-plan-toggle]').forEach(function (b) {
      b.addEventListener('click', function () { state.plan = b.dataset.planToggle; render(); });
      b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); b.click(); } });
    });
    qa('[data-stack]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.stack = parseInt(b.dataset.stack, 10);
        qa('[data-stack]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true'); render();
      });
    });
    qa('[data-freq]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.planId = b.dataset.planId || '';
        qa('[data-freq]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
      });
    });
    var qv = q('[data-qty]');
    qa('[data-qstep]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.qty = Math.max(1, state.qty + parseInt(b.dataset.qstep, 10));
        if (qv) qv.textContent = state.qty; render();
      });
    });

    function openCart() {
      var drawer = document.getElementById('site-cart-sidebar');
      if (drawer && typeof drawer.show === 'function') { drawer.show(); return; }
      var handle = document.querySelector('[data-js-sidebar-handle][aria-controls="site-cart-sidebar"]');
      if (handle) { handle.click(); return; }
      window.location = cartUrl;
    }
    function setText(sel, val) { document.querySelectorAll(sel).forEach(function (e) { e.textContent = val; }); }
    function refreshDrawer() {
      // Re-render Krown's cart drawer exactly the way the theme does, so it never shows stale contents.
      var live = document.getElementById('AjaxCartForm');
      if (!live) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { setText('[data-header-cart-count]', c.item_count); })
          .catch(function () {});
      }
      return fetch('?section_id=helper-cart')
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var nf = doc.getElementById('AjaxCartForm');
          if (nf) { live.innerHTML = nf.innerHTML; if (typeof live.ajaxifyCartItems === 'function') { live.ajaxifyCartItems(); } }
          var ls = document.getElementById('AjaxCartSubtotal'), ns = doc.getElementById('AjaxCartSubtotal');
          if (ls && ns) { ls.innerHTML = ns.innerHTML; }
          var cc = doc.querySelector('[data-cart-count]'); if (cc) { setText('[data-header-cart-count]', cc.textContent.trim()); }
          var ct = doc.querySelector('[data-cart-total]'); if (ct) { setText('[data-header-cart-total]', ct.textContent.trim()); }
          var drawer = document.getElementById('site-cart-sidebar'); if (drawer) { drawer.classList.remove('cart-is-empty'); }
        })
        .catch(function () {});
    }
    function add() {
      if (!variantId) { return; }
      var sub = state.plan === 'sub';
      var item = { id: variantId, quantity: sub ? state.stack : state.qty };
      if (sub && state.planId) { item.selling_plan = state.planId; }
      var btns = qa('[data-atc]'); btns.forEach(function (b) { b.disabled = true; });
      fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw e; }); } return r.json(); })
        .then(function () {
          if (toCheckout) { window.location = checkoutUrl; return; }   // straight-to-checkout pages skip the drawer
          return refreshDrawer().then(function () { openCart(); });
        })
        .catch(function () { window.location = cartUrl; })
        .finally(function () { btns.forEach(function (b) { b.disabled = false; }); });
    }
    qa('[data-atc]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); add(); }); });

    var buy = q('[data-buybox]');
    var sticky = document.querySelector('[data-uc-sticky]');
    if (buy && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { sticky.classList.toggle('show', !es[0].isIntersecting); }, { rootMargin: '-220px 0px 0px 0px' }).observe(buy);
    }

    qa('[data-faq] .q button').forEach(function (b) {
      b.addEventListener('click', function () {
        var it = b.closest('.q');
        it.setAttribute('aria-expanded', String(it.getAttribute('aria-expanded') !== 'true'));
      });
    });

    (function () {
      var main = q('[data-main-media]');
      if (!main) return;
      var thumbs = qa('[data-thumb]');
      var mainImg = main.querySelector('img');
      var prev = q('[data-gprev]'), next = q('[data-gnext]');
      var idx = 0;
      function setIdx(i) {
        if (!thumbs.length || !mainImg) return;
        idx = (i + thumbs.length) % thumbs.length;
        var full = thumbs[idx].getAttribute('data-full');
        if (full) { mainImg.src = full; }
        thumbs.forEach(function (o) { o.classList.remove('active'); });
        thumbs[idx].classList.add('active');
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { setIdx(i); }); });
      if (prev) { prev.addEventListener('click', function (e) { e.preventDefault(); setIdx(idx - 1); }); }
      if (next) { next.addEventListener('click', function (e) { e.preventDefault(); setIdx(idx + 1); }); }
    })();

    var ds = q('[data-stack][aria-pressed="true"]') || q('[data-stack]');
    if (ds) { state.stack = parseInt(ds.dataset.stack, 10) || state.stack; }
    render();
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-uc-pdp]')).forEach(initPDP);
  });
})();
